var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIconTfi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/Dashboard/BlueTFI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HSP-view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-59.000000, -226.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/Dashboard/BlueTFI",
    transform: "translate(59.000000, 227.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,10 L13,10 C13.5522847,10 14,10.4477153 14,11 L14,29 L8,29 L8,11 C8,10.4477153 8.44771525,10 9,10 Z",
    id: "Rectangle",
    fill: "#002C56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,17 L5,17 C5.55228475,17 6,17.4477153 6,18 L6,29 L0,29 L0,18 C-6.76353751e-17,17.4477153 0.44771525,17 1,17 Z",
    id: "Rectangle-Copy-3",
    fill: "#002C56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,13 L21,13 C21.5522847,13 22,13.4477153 22,14 L22,29 L16,29 L16,14 C16,13.4477153 16.4477153,13 17,13 Z",
    id: "Rectangle-Copy",
    fill: "#002C56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,6 L29,6 C29.5522847,6 30,6.44771525 30,7 L30,29 L24,29 L24,7 C24,6.44771525 24.4477153,6 25,6 Z",
    id: "Rectangle-Copy-2",
    fill: "#002C56"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-6",
    stroke: "#002C56",
    points: "3 12.5 11 5.5 19 8.5 27 1.5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    stroke: "#002C56",
    strokeWidth: 0.5,
    fill: "#002C56",
    cx: 3,
    cy: 12.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    stroke: "#002C56",
    strokeWidth: 0.5,
    fill: "#002C56",
    cx: 11,
    cy: 5.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    stroke: "#002C56",
    strokeWidth: 0.5,
    fill: "#002C56",
    cx: 19,
    cy: 8.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    stroke: "#002C56",
    strokeWidth: 0.5,
    fill: "#002C56",
    cx: 27,
    cy: 1.5,
    r: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconTfi);
export default __webpack_public_path__ + "static/media/dashboard_icon_tfi.e1ee2529f10a01535846436def7df701.svg";
export { ForwardRef as ReactComponent };